import clsx from 'clsx';
import React from 'react';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { default as CommonAcitivities } from '@/src/components/project/Common/Activities/Activities';

import { useFileEntryViewerInfoPanel } from '../../../store/fileEntryViewer.infoPanel.store';

const ActivityLogs = ({ projectId, fileEntry }) => {
  const { infoPanelQueries } = useFileEntryViewerInfoPanel();
  const { useActivityLogsQuery } = infoPanelQueries;
  const activityLogsQuery = useActivityLogsQuery();

  if (activityLogsQuery.isLoading) {
    return (
      <SectionLoader
        className={clsx(
          'tw-flex tw-flex-col tw-items-center tw-justify-center',
          'tw-h-full',
          'tw-px-[10px]'
        )}
      />
    );
  }

  const document = {
    id: fileEntry.file.id,
    linkId: fileEntry.file.id,
    isActive: fileEntry.isActive || true,
    isDeleted: fileEntry.isDeleted || false,
    origin: fileEntry.file.name,
    linkSubject: fileEntry.file.name,
  };

  return (
    <div
      className={clsx('tabContents--activityLogs', 'tw-px-[20px] tw-flex tw-flex-col tw-h-full')}
    >
      <CommonAcitivities
        document={document}
        projectId={projectId}
        includeDate={true}
        isLoading={activityLogsQuery.isLoading}
        activityLogs={activityLogsQuery.data?.data || []}
      />
    </div>
  );
};

export default ActivityLogs;
